import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Calendar, Users, Clock, CheckCircle, ArrowRight } from 'lucide-react';
import RegistrationForm from './Zero2ExportRegistrationForm';

const Zero2ExportHero = () => {
  const [isRegistrationOpen, setIsRegistrationOpen] = useState(false);

  const handleEnrollClick = () => {
    const packageSection = document.getElementById('zero2export-packages');
    if (packageSection) {
      packageSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="relative min-h-screen">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-1.2.1&auto=format&fit=crop&w=2850&q=80"
          alt="Zero2Export Program"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 to-black/70" />
      </div>

      {/* Content */}
      <div className="relative min-h-screen flex flex-col justify-center px-4 sm:px-6 lg:px-8 py-32">
        <div className="max-w-7xl mx-auto w-full">
          <div className="max-w-3xl">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <span className="inline-block px-4 py-2 rounded-full text-sm font-medium bg-blue-600 text-white mb-6">
                Scale-Up Program
              </span>
              <h1 className="text-4xl font-bold text-white sm:text-5xl md:text-6xl mb-6">
                Zero2Export™
              </h1>
              <p className="text-xl text-gray-300 mb-8">
                Transform from a complete beginner to a professional exporter with our comprehensive training program.
              </p>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
                <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
                  <Calendar className="h-6 w-6 text-blue-400 mb-2" />
                  <div className="text-sm text-gray-300">Duration</div>
                  <div className="text-lg text-white font-semibold">2 Days</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
                  <Users className="h-6 w-6 text-blue-400 mb-2" />
                  <div className="text-sm text-gray-300">Class Size</div>
                  <div className="text-lg text-white font-semibold">30 Students</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
                  <Clock className="h-6 w-6 text-blue-400 mb-2" />
                  <div className="text-sm text-gray-300">Next Cohort</div>
                  <div className="text-lg text-white font-semibold">July 2025</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
                  <CheckCircle className="h-6 w-6 text-blue-400 mb-2" />
                  <div className="text-sm text-gray-300">Certification</div>
                  <div className="text-lg text-white font-semibold">Included</div>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4">
                <button
                  onClick={handleEnrollClick}
                  className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-lg text-white bg-blue-600 hover:bg-blue-700 transition-colors"
                >
                  Enroll Now - ₦160,000
                  <ArrowRight className="ml-2 h-5 w-5" />
                </button>
                <button
                  onClick={() => window.open('https://drive.google.com/file/d/1xWG-KxL7XB1wo3LoPPyRsQv5ht1diEdT/view?usp=sharing', '_blank')}
                  className="inline-flex items-center justify-center px-6 py-3 border-2 border-white text-base font-medium rounded-lg text-white hover:bg-white/10 transition-colors"
                >
                  Download Brochure
                </button>
              </div>
            </motion.div>
          </div>
        </div>
      </div>

      <RegistrationForm
        isOpen={isRegistrationOpen}
        onClose={() => setIsRegistrationOpen(false)}
      />
    </div>
  );
};

export default Zero2ExportHero;